var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTransactionDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "transaction (1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.4 0H18.4C19.7255 0 20.8 1.07452 20.8 2.4V17.6C20.8 18.9255 19.7255 20 18.4 20H2.4C1.07452 20 0 18.9255 0 17.6V2.4C0 1.07452 1.07452 0 2.4 0ZM18.4 18.4C18.8418 18.4 19.2 18.0418 19.2 17.6V2.4C19.2 1.95817 18.8418 1.6 18.4 1.6H2.4C1.95817 1.6 1.6 1.95817 1.6 2.4V17.6C1.6 18.0418 1.95817 18.4 2.4 18.4H18.4Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M15.6001 8.79999C16.0419 8.79999 16.4001 8.44182 16.4001 7.99999C16.4001 7.55816 16.0419 7.19999 15.6001 7.19999H6.73205L7.76805 6.16399C8.08065 5.8514 8.08065 5.34458 7.76805 5.03199C7.45546 4.7194 6.94865 4.7194 6.63605 5.03199L4.23605 7.43199C4.00581 7.66035 3.9362 8.00511 4.05981 8.30492C4.18341 8.60472 4.47577 8.80025 4.80005 8.79999H15.6001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M16.4 11.6H5.60005C5.15822 11.6 4.80005 11.9582 4.80005 12.4C4.80005 12.8418 5.15822 13.2 5.60005 13.2H14.468L13.432 14.236C13.1195 14.5486 13.1195 15.0554 13.432 15.368C13.7446 15.6806 14.2515 15.6806 14.564 15.368L16.964 12.968C17.1943 12.7396 17.2639 12.3949 17.1403 12.0951C17.0167 11.7953 16.7243 11.5997 16.4 11.6Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransactionDashboard);
export default __webpack_public_path__ + "static/media/icon_transaction_dashboard.28471192.svg";
export { ForwardRef as ReactComponent };